import { clamp } from "./model.ts";

export function projectToMinimap(
  x: number,
  y: number,
  worldWidth: number,
  worldHeight: number,
  mapWidth: number,
  mapHeight: number,
  padding = 6,
) {
  const usableWidth = Math.max(1, mapWidth - padding * 2);
  const usableHeight = Math.max(1, mapHeight - padding * 2);
  return {
    x: padding + clamp(x / Math.max(1, worldWidth), 0, 1) * usableWidth,
    y: padding + clamp(y / Math.max(1, worldHeight), 0, 1) * usableHeight,
  };
}

export function getMinimapViewport(
  cameraX: number,
  cameraY: number,
  viewportWidth: number,
  viewportHeight: number,
  worldWidth: number,
  worldHeight: number,
  mapWidth: number,
  mapHeight: number,
  padding = 6,
) {
  const topLeft = projectToMinimap(cameraX, cameraY, worldWidth, worldHeight, mapWidth, mapHeight, padding);
  const bottomRight = projectToMinimap(cameraX + viewportWidth, cameraY + viewportHeight, worldWidth, worldHeight, mapWidth, mapHeight, padding);
  return { x: topLeft.x, y: topLeft.y, width: bottomRight.x - topLeft.x, height: bottomRight.y - topLeft.y };
}
